import { makeFieldValueDbModule } from '../makeFieldValueDbModule';
import { clear as injuryTypesServiceClear } from './injuryTypesService';
import { makeClearPublisher } from 'serviceWorker/broadcasts/publishers';
import { fieldValueContracts } from 'shared/domain/fieldValue/fieldValueContracts';
import { EditableFieldValuesEntityName } from 'shared/domain/fieldValue/fields';

export const {
  clear,
  quantity,
  get,
  getOne,
  addBatch,
  updateBatch,
  removeBatch,
} = makeFieldValueDbModule({
  tableName: 'injuryTypes',
  serviceTableName: 'injuryTypesService',
  serviceClearFunction: injuryTypesServiceClear,
  broadcastClearFunction: makeClearPublisher(fieldValueContracts[EditableFieldValuesEntityName.injuryType]),
});
